import Button from '../Button';
import type { EditorPanelProps } from './EditorPanel.types';

const panelBaseClasses =
  'tw:mt-3 tw:mb-1 tw:flex tw:w-full tw:max-w-md tw:flex-col tw:items-start tw:rounded-3xl tw:border tw:border-sq-tool-btn-border tw:dark:border-gray-500 tw:bg-sq-surface tw:dark:bg-sq-tools-background-dark tw:px-4 tw:py-3 tw:shadow-sm';

const panelGapBySpacing = {
  normal: 'tw:gap-2',
  spacious: 'tw:gap-3',
} as const;

const panelTitleClasses = 'tw:text-xs tw:font-bold tw:uppercase tw:tracking-wide tw:text-sq-theme-dark';

const actionRowClasses = 'tw:flex tw:w-full tw:max-w-full tw:flex-wrap tw:items-center tw:justify-end tw:gap-2';

const EditorPanel = ({
  title,
  children,
  onApply,
  onCancel,
  isApplyDisabled = false,
  applyLabel = 'Apply',
  cancelLabel = 'Cancel',
  spacing = 'normal',
  extraClassNames = '',
  id,
  testId,
}: EditorPanelProps) => (
  <div className={`${panelBaseClasses} ${panelGapBySpacing[spacing]} ${extraClassNames}`} data-testid={testId} id={id}>
    <span className={panelTitleClasses}>{title}</span>
    {children}
    <div className={actionRowClasses}>
      {onCancel && <Button label={cancelLabel} onClick={onCancel} size="sm" variant="outline" />}
      {onApply && <Button disabled={isApplyDisabled} label={applyLabel} onClick={onApply} size="sm" variant="theme" />}
    </div>
  </div>
);

export default EditorPanel;
